import { render, staticRenderFns } from "./PermissionsInputField.vue?vue&type=template&id=70cb5264&scoped=true&"
import script from "./PermissionsInputField.vue?vue&type=script&lang=js&"
export * from "./PermissionsInputField.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsInputField.vue?vue&type=style&index=0&id=70cb5264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cb5264",
  null
  
)

export default component.exports